import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/layout/Pagination'
import { toast } from 'react-toastify';

function CarFilterConnections() {
  const [products, setProducts] = useState([])
  const token = localStorage.getItem('authToken');
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [searchedFilter, setSearchedFilter] = useState('');

  const API_URL = process.env.REACT_APP_API_URL;

  const location = useLocation()
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sortByUrl = queryParams.get('sortBy') ?? '';
    const pageSizeUrl = queryParams.get('pageSize') ?? pageSize;
    const currentPageUrl = queryParams.get('currentPage') ?? 1;
    const totalPagesUrl = queryParams.get('totalPages') ?? 0;
    setCurrentPage(currentPageUrl)
    setTotalPages(totalPagesUrl)
    setSortBy(sortByUrl)
    setPageSize(pageSizeUrl)
    fetchFilters(searchedFilter, sortByUrl, pageSizeUrl, currentPage)
  }, [location.search, currentPage])

  const fetchFilters = async (searchedFilter, sortBy, pageSize, currentPage) => {
    try {
      setLoading(true)

      const response = await fetch(`${API_URL}/Item/filters?filterName=${searchedFilter}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',  // Specify the content type
        }
      })

      if (response.status === 401) {
        navigate('/');
      }

      const result = await response.json()
      if (result?.data?.items) {
        const newQueryParams = new URLSearchParams(location.search);
        setProducts(result.data.items);
        setTotalPages(result.data.totalPages);
        setTotalItems(result.data.totalItems);
        setLoading(false)

        if (result.data.totalPages) {
          newQueryParams.set("totalPages", result.data.totalPages);
        }
        //navigate({ search: newQueryParams.toString() });
      } else {
        setProducts([])
        setLoading(false)
      }
    }
    catch (error) {
    }
  }

  const handlePageChange = (page) => {
    const newQueryParams = new URLSearchParams(location.search);

    if (page) {
      newQueryParams.set('currentPage', page);
    } else {
      newQueryParams.delete('currentPage');
    }
    navigate({ search: newQueryParams.toString() });

    setCurrentPage(page)
  };

  const handleSortByChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setSortBy(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handlePageSizeChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set('currentPage', '1');
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setPageSize(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchIconClick(); // Повикај ја функцијата ако е притиснат Enter
    }
    if(event.key === 'Escape'){
      clearInput();
    }
  };

  const handleSearchIconClick = () => {
    if (searchedFilter.length > 0 && searchedFilter.length < 2) {
      return;
    }
    fetchFilters(searchedFilter, sortBy, pageSize, currentPage);
  };

  const clearInput = () => {
    setSearchedFilter('');
    fetchFilters('', sortBy, pageSize, currentPage);
  };

  return (
    <div className="p-6">
      <div className='flex flex-col'>
        <div className='ml-auto'>
          <label htmlFor='pageSize'>Прикажи:</label>
          <select
            className="mb-4"
            name='pageSize'
            id='pageSize'
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
        <div className='ml-auto'>
          <select
            className="mb-4"
            name='sortBy'
            value={sortBy}
            onChange={handleSortByChange}
          >
            <option value="">Стандардно подредување</option>
            <option value="price_asc">Цена &uarr; (ниска кон висока)</option>
            <option value="price_desc">Цена &darr; (висока кон ниска)</option>
            <option value="createdate">Најново додадено</option>
          </select>
        </div>
      </div>
      <div className='flex justify-between'>
        <div className="flex items-center border border-gray-300 rounded-lg p-[1px] max-w-[200px] mr-1">
          <input
            type="text"
            className="flex-grow p-1 outline-none w-full"
            placeholder="Пребарувај продукти"
            value={searchedFilter}
            onChange={(e) => setSearchedFilter(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          {searchedFilter && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-5 w-5 text-gray-500 cursor-pointer"
              onClick={clearInput}
            >
              <path
                fillRule="evenodd"
                d="M11.03 4.97a1 1 0 0 0-1.415 0L8 6.585 5.385 4.97a1 1 0 1 0-1.415 1.415L6.585 8l-2.615 2.615a1 1 0 1 0 1.415 1.415L8 9.415l2.615 2.615a1 1 0 0 0 1.415-1.415L9.415 8l2.615-2.615a1 1 0 0 0 0-1.415z"
                clipRule="evenodd"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="h-5 w-5 text-gray-500 cursor-pointer"
            onClick={handleSearchIconClick}
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="table min-w-[600px] w-full">
          <thead>
            <tr className='text-sm'>
              <th className='w-[30px]'>Id</th>
              <th>Слика</th>
              <th>Продукт</th>
              <th>Категорија</th>
              <th>Количество</th>
              <th>Цена</th>
              <th>Конекции</th>
            </tr>
          </thead>
          <tbody>
            {products.map(product => (
              <tr key={product.id}>
                <td className='font-semibold'>{product.id}</td>
                <td className='p-0'><img className='w-[55px]' src={product.imageLinks[0]?.imageLink} /></td>
                <td className='max-w-[200px]'>{product.title}</td>
                <td className='max-w-[200px]'>{product.categoryDescription}</td>
                <td className='flex items-center'>
                  <p className='inline-block w-[30px] text-right mr-[10px] text-base font-semibold'>{product.stock}</p>
                </td>
                <td>{product.price} ден</td>
                <td>
                  <div className="tooltip" data-tip="Види конекции">
                    <Link
                      to={`/wrongPage/carFilterConnectionTest1/${product.id}`}
                      className="btn btn-sm btn-primary ml-2"
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {products.length > 0 && (
          <>
            <div className='text-center'>Тековна страна: {currentPage}</div>
            <div className='text-center'>Вкупно производи: {totalItems}</div>
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            /></>
        )}
      </div>
    </div>
  )
}

export default CarFilterConnections
